var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.pageViewerVisible
    ? _c("IframeContainer", { attrs: { source: _vm.pageViewerSource } })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }